import * as React from 'react';

import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  TextField,
} from '@mui/material';

interface IncidentReopenButtonProps {
  onReopen: (reason: string) => void;
}

function IncidentReopenButton({ onReopen }: IncidentReopenButtonProps): React.JSX.Element {
  const [isDialogOpen, setIsDialogOpen] = React.useState<boolean>(false);
  const [reopenReason, setReopenReason] = React.useState<string>('');

  const openDialog = () => setIsDialogOpen(true);
  const closeDialog = () => setIsDialogOpen(false);

  const handleReopenReasonChange = (e: React.ChangeEvent<HTMLInputElement>) => setReopenReason(e.target.value);

  const handleCancel = () => {
    setReopenReason('');
    closeDialog();
  };

  const handleConfirm = () => {
    closeDialog();
    onReopen(reopenReason);
  };

  return (
    <React.Fragment>
      <Button onClick={openDialog}>ReOpen</Button>
      <Dialog open={isDialogOpen} onClose={closeDialog} maxWidth="md" fullWidth>
        <DialogTitle>Confirm Reopen</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Please provide a reason for reopening
          </DialogContentText>
          <TextField
            autoFocus
            required
            fullWidth
            label="Reopen Reason"
            variant="standard"
            value={reopenReason}
            onChange={handleReopenReasonChange}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCancel}>Cancel</Button>
          <Button disabled={reopenReason.length < 5} onClick={handleConfirm}>
            Confirm Reopen
          </Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
}

export default IncidentReopenButton;
